module.exports = __webpack_public_path__ + "img/minting_mine.a45c8388.png";